<template>
    <div class="messageDetailsBox">
        <div class="messageDetails">
            <div style="margin-bottom: 10px">{{content.msg_type}}</div>
            <div style="font-size: 14px">{{content.create_time}}</div>
        </div>
        <div class="contentBox">
            <p>{{content.content}}</p>
        </div>
        <el-button class="customize" @click="dealWith">立即处理</el-button>
    </div>
</template>

<script>
    import { messageData } from '../../../api/personal';
    import { uponMySignature } from '../../../api/contract';

    export default {
        name: 'messagePage',
        data(){
            return{
                content:''
            }
        },
        methods:{
            dealWith(){
                if (this.content.to_type==1){
                    this.$router.push({path:'/evidenceList',query:{id:this.content.signer_list_id,is_main:this.content.is_main}})
                    return
                }else if(this.content.to_type==2){
                    uponMySignature(this.content.signer_list_id).then(res=>{
                        if (res.code==200){
                            this.fullscreenLoading=false
                            const link = document.createElement("a"); //自己创建的a标签
                            link.href = res.data.sign_url+'?v='+Math.random();
                            // link.target="_blank"
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(res.data.sign_url);
                        }else {
                            this.fullscreenLoading=false
                            this.$message.error(res.msg)
                        }
                    })
                }
            }
        },
        created() {
            messageData(this.$route.query.id).then(res=>{
                if (res.code==200){
                    this.content=res.data
                }
            })
        }
    };
</script>

<style scoped>
    .messageDetailsBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
        color: #333333;
    }
    .contentBox{
        margin: 10px 0px 40px 0px;
    }
    .contentBox>p{
        font-size: 14px;
    }
    .customize{
        background-color: #3e62f6;
        color: #fff;
        display: block;
        margin: auto;
    }
</style>
